import React from "react";

const Sidebar = ({ currentSection, navigateTo, closeSidebar, onLogout }) => {
  return (
    <aside className="sidebar">
      <button className="sidebar-close" onClick={closeSidebar}>
        <i className="fas fa-times"></i>
      </button>
      <div className="sidebar-header">
        <img src="/assets/logo.png" alt="Travelscape Logo" className="sidebar-logo" />
        <h3 style={{ fontSize: '1.1rem', marginBottom: '0.25rem', color: 'white' }}>Travelscape Admin</h3>
      </div>
      <ul className="sidebar-menu">
        <li className={currentSection === "dashboard" ? "active" : ""}>
          <a href="#" onClick={(e) => { e.preventDefault(); navigateTo("dashboard"); }}>
            <i className="fas fa-tachometer-alt"></i>
            <span>Dashboard</span>
          </a>
        </li>
        <li className={currentSection === "trips" ? "active" : ""}>
          <a href="#" onClick={(e) => { e.preventDefault(); navigateTo("trips"); }}>
            <i className="fas fa-suitcase"></i>
            <span>Trips</span>
          </a>
        </li>
        <li className={currentSection === "reviews" ? "active" : ""}>
          <a href="#" onClick={(e) => { e.preventDefault(); navigateTo("reviews"); }}>
            <i className="fas fa-star"></i>
            <span>Reviews</span>
          </a>
        </li>
        <li className={currentSection === "inquiries" ? "active" : ""}>
          <a href="#" onClick={(e) => { e.preventDefault(); navigateTo("inquiries"); }}>
            <i className="fas fa-question-circle"></i>
            <span>Enquiries</span>
          </a>
        </li>
        <li className={currentSection === "settings" ? "active" : ""}>
          <a href="#" onClick={(e) => { e.preventDefault(); navigateTo("settings"); }}>
            <i className="fas fa-cog"></i>
            <span>Settings</span>
          </a>
        </li>
        <li className={currentSection === "gallery" ? "active" : ""}>
          <a href="#" onClick={(e) => { e.preventDefault(); navigateTo("gallery"); }}>
            <i className="fas fa-image"></i>
            <span>Gallery</span>
          </a>
        </li>
        {/* 
        <li className={currentSection === "categories" ? "active" : ""}>
          <a href="#" onClick={(e) => { e.preventDefault(); navigateTo("categories"); }}>
            <i className="fas fa-folder-plus"></i>
            <span>Add Subcategories</span>
          </a>
        </li>
        <li className={currentSection === "updateImages" ? "active" : ""}>
          <a href="#" onClick={(e) => { e.preventDefault(); navigateTo("updateImages"); }}>
            <i className="fas fa-image"></i>
            <span>Update Images</span>
          </a>
        </li>
        */}
      </ul>
      <div className="sidebar-footer">
        <button id="logoutBtn" className="btn btn-link text-white p-0" onClick={onLogout}>
          <i className="fas fa-sign-out-alt me-2"></i>
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
